import { Controller } from '@hotwired/stimulus';
import { useEventListener } from 'stimulus-library/dist';

export default class extends Controller {
  static targets = ['enabler', 'enablee'];

  initialize() {
    this.toggle = this.toggle.bind(this);
    this.enable = this.enable.bind(this);
    this.disable = this.disable.bind(this);
    this.enablees = this.enablees.bind(this);
  }

  connect() {
    this.enablerTargets.forEach(
      (enabler) => useEventListener(this, enabler, 'change', () => this.toggle(enabler)),
    );
  }

  enablees(enabler) {
    return Array.from(
      this.enableeTargets.filter(
        (enablee) => enablee.dataset.enableGroup === enabler.dataset.enableGroup,
      ),
    );
  }

  toggle(enabler) {
    if (this.enablerTargets.some((el) => el.checked)) {
      this.enable(enabler);
    } else {
      this.disable(enabler);
    }
  }

  enable(enabler) {
    this.enablees(enabler).forEach((el) => {
      el.disabled = false;
    });
  }

  disable(enabler) {
    this.enablees(enabler).forEach((el) => {
      el.disabled = true;
    });
  }
}
